import moment from "moment";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { CongeDto } from "../../../../dto/GenApi.iNotPaie.Dto/CongeDto";
import { EtatAbsencesEnum } from "../../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import { JourFerieDto } from "../../../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";

interface modelDay {
	textDay: number;
	dateDay: Date;
	isOtherMonth: boolean,
	isFerie: boolean;
}

@Component({
	components: {
		DatePickerModal: require("../../../calendrier/datePickerModal/datePickerModal.vue.html")
	}
})
export default class DoubleCalendrier extends Vue {
	public daysName: string[] = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
	public monthNames: string[] = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
	public currentCells: modelDay[] = [];
	public nextCells: modelDay[] = [];
	public maxCell = 42;
	public startLimitDate: Date = moment.utc("01/1950", "MM-YYYY").startOf("month").toDate();
	public lastLimitDate: Date = moment.utc("12/2050", "MM-YYYY").endOf("month").toDate();
	public nextDate: Date = new Date();
	public hideLastMonth = false;
	public hideLastYear = false;
	public currentMonth = 0;
	public currentYear = 0;
	public filterYear = 0;
	public nextMonth = 0;
	public nextYear = 0;
	public disabledLeft = false;
	public disabledRight = false;
	public disabledReset = false;
	public errorYear = false;
	public voirToutSalaries = false;

	@Prop()
	public dataReady = false;

	public listeJourFerie: JourFerieDto[] = [];

	@Prop()
	public listAbsenceSalarie: CongeDto[] = [];

	@Prop()
	public currentDate: Date = new Date();

	@Prop()
	public currentId = 0;

	@Watch("currentDate")
	public async onStatutChanged(): Promise<void> {
		if (this.listeJourFerie.length == 0) {
			await ServicesFactoryInstance.JoursFeriesService.getJoursFeries(data => {
				this.listeJourFerie = data;
			});
		}
		this.currentMonth = this.currentDate.getUTCMonth();
		this.currentYear = this.currentDate.getUTCFullYear();
		this.filterYear = this.currentYear;
		const nextMonth = moment.utc(this.currentDate).add(1, "M").toDate();
		this.nextMonth = nextMonth.getUTCMonth();
		this.nextYear = nextMonth.getUTCFullYear();
		this.currentCells = this.getDays(this.currentMonth, this.currentYear);
		this.nextCells = this.getDays(this.nextMonth, this.nextYear);
		this.$emit("firstDate", this.currentCells[0].dateDay.toDateString());
		this.$emit("lastDate", this.nextCells[this.nextCells.length - 1].dateDay.toDateString());
	}

	public onVoirToutSalariesChanged(): void {
		const salarieAbsences = {
			IdSalarie: this.currentId,
			VoirToutSalaries: this.voirToutSalaries ? 1 : 0
		};

		ServicesFactoryInstance.SalarieService.updateSalarieAbsences(salarieAbsences);
	}

	@Watch("currentId")
	public onCurrentIdCherchePropertyChanged(): void {
		if (this.currentId != undefined && this.currentId != 0) {
			ServicesFactoryInstance.SalarieService.getSalarieAbsences(this.currentId, data => {
				if (data.VoirToutSalaries == 1) {
					this.voirToutSalaries = true;
				} else {
					this.voirToutSalaries = false;
				}
			});
		}
	}

	public testDisableButton(): void {
		this.disabledLeft = moment.utc(this.currentDate).isBefore(moment.utc(this.startLimitDate).add(1, "month"));
		this.disabledRight = moment.utc(this.currentDate).isAfter(moment.utc(this.lastLimitDate).subtract(2, "month"));
		this.disabledReset = this.currentDate.getUTCFullYear() == new Date().getUTCFullYear() && this.currentDate.getUTCMonth() == new Date().getUTCMonth();
		this.hideLastMonth = this.currentYear == 2050;
	}

	public previous(): void {
		if (!this.disabledLeft) {
			this.$emit("previous");
		}
	}

	public next(): void {
		if (!this.disabledRight) {
			this.$emit("next");
		}
	}

	public reset(): void {
		this.errorYear = false;
		this.$emit("reload", new Date().getUTCMonth(), new Date().getUTCFullYear());
	}

	public monthFilter(): void {
		this.$emit("reload", this.currentMonth, this.currentYear);
	}

	public yearFilter(): void {
		const lastLimit = (this.currentMonth == 11) ? 2049 : 2050;
		this.errorYear = true;

		if (this.filterYear >= this.startLimitDate.getUTCFullYear() && this.filterYear <= lastLimit) {
			this.$emit("reload", this.currentMonth, this.filterYear);
			this.errorYear = false;
		}
	}

	public getDays(month: number, yearCurrent: number): any {
		// INIT
		let cells: modelDay[] = [];
		let yearLast = yearCurrent;
		let yearNext = yearCurrent;
		const monthCurrent = month + 1;
		let monthLast = monthCurrent - 1;
		let monthNext = monthCurrent + 1;

		if (monthLast < 1) {
			monthLast = 12;
			yearLast -= 1;
		}

		if (monthNext > 12) {
			monthNext = 1;
			yearNext += 1;
		}

		const dateCurrent = moment.utc(yearCurrent + "-" + monthCurrent + "-1", "YYYY-MM-DD");
		const dateLast = moment.utc(yearLast + "-" + monthLast + "-1", "YYYY-MM-DD");
		const dateNext = moment.utc(yearNext + "-" + monthNext + "-1", "YYYY-MM-DD");

		let positionFirstDay = 0;

		let totalDaysCurrentMonth = moment.utc(yearCurrent + "-" + monthCurrent, "YYYY-MM").daysInMonth();
		let totalDaysLastMonth = moment.utc(yearLast + "-" + monthLast, "YYYY-MM").daysInMonth();

		// CURRENT MONTH
		while (totalDaysCurrentMonth) {
			const iterationDate = dateCurrent.date(totalDaysCurrentMonth);

			if (iterationDate.date() == 1) {
				positionFirstDay = iterationDate.day();
			}

			const isFerie = this.listeJourFerie.filter(a => moment.utc(a.Date).isSame(iterationDate))[0];

			cells.push({
				textDay: totalDaysCurrentMonth,
				dateDay: iterationDate.toDate(),
				isOtherMonth: false,
				isFerie: (isFerie != undefined)
			});

			totalDaysCurrentMonth--;
		}

		cells.reverse();

		// LAST MONTH
		if (positionFirstDay != 1) {
			const cellsLast: modelDay[] = [];

			if (positionFirstDay == 0) {
				positionFirstDay = 7;
			}

			for (let i = positionFirstDay; i > 1; i--) {
				const lastDate = dateLast.date(totalDaysLastMonth);

				const isFerie = this.listeJourFerie.filter(a => moment.utc(a.Date).isSame(lastDate))[0];

				cellsLast.push({
					textDay: totalDaysLastMonth,
					dateDay: lastDate.toDate(),
					isOtherMonth: true,
					isFerie: (isFerie != undefined)
				});

				totalDaysLastMonth--;
			}

			cellsLast.reverse();
			cells = cellsLast.concat(cells);
		}

		// NEXT MONTH
		if (cells.length < this.maxCell) {
			const cellsNext: modelDay[] = [];

			for (let i = 1; i <= this.maxCell - cells.length; i++) {
				const nextDate = dateNext.date(i);
				const isFerie = this.listeJourFerie.filter(a => moment.utc(a.Date).isSame(nextDate))[0];

				cellsNext.push({
					textDay: i,
					dateDay: nextDate.toDate(),
					isOtherMonth: true,
					isFerie: (isFerie != undefined)
				});
			}

			cells = cells.concat(cellsNext);
		}

		return cells;
	}

	public yearFilterPrevent(e: any): void {
		const keyCode = (e.keyCode ? e.keyCode : e.which);
		if (keyCode < 48 || keyCode > 57) {
			e.preventDefault();
		}
	}

	public getClassCell(cell: modelDay, type: string): string {
		const dateCellule = moment.utc(cell.dateDay);
		const conges = this.listAbsenceSalarie.filter(a => dateCellule.isSameOrAfter(moment.utc(a.Date), "day") && dateCellule.isSameOrBefore(moment.utc(a.Date), "day"));

		if (conges.length == 0) {
			// Si il n'y a pas de congés posés et que c'est le jour actuel, on encadre le numéro
			if (this.isToday(cell.dateDay)) {
				return "cell-today";
			}

			return "";
		}

		let cellClass = "";
		let isWait = "";

		if (conges.length == 1 && type == "cell") {
			if (conges[0].IsFirst && !conges[0].IsLast && conges[0].IsMatin && !conges[0].IsApresMidi) {
				cellClass = cellClass + " cell-left ";
			} else if (!conges[0].IsFirst && conges[0].IsLast && !conges[0].IsMatin && conges[0].IsApresMidi) {
				cellClass = cellClass + " cell-right ";
			} else {
				if (!conges[0].IsFirst && !conges[0].IsLast) {
					cellClass = cellClass + " cell-middle ";
				} else if (conges[0].IsFirst && conges[0].IsLast && !conges[0].IsMatin && !conges[0].IsApresMidi) {
					cellClass = cellClass + " cell-one ";
				} else if (conges[0].IsFirst && !conges[0].IsLast && !conges[0].IsMatin && !conges[0].IsApresMidi) {
					cellClass = cellClass + " cell-left ";
				} else if (conges[0].IsLast && !conges[0].IsFirst && !conges[0].IsMatin && !conges[0].IsApresMidi) {
					cellClass = cellClass + " cell-right ";
				} else if (conges[0].IsMatin && conges[0].IsFirst && conges[0].IsLast) {
					cellClass = cellClass + " cell-one-demi-m ";
				} else if (conges[0].IsApresMidi && conges[0].IsFirst && conges[0].IsLast) {
					cellClass = cellClass + " cell-one-demi-a ";
				} else if (conges[0].IsFirst && !conges[0].IsLast) {
					cellClass = cellClass + " cell-left-demi ";
				} else if (conges[0].IsLast && !conges[0].IsFirst) {
					cellClass = cellClass + " cell-right-demi ";
				}
			}

			if (!this.estValideOuPlus(conges[0].Etat)) {
				cellClass = cellClass + " wait ";
			}
		} else if (conges.length == 2 && type == "cell") {
			if (dateCellule.isBefore(conges[0].Fin, "day") && dateCellule.isSame(conges[0].Debut, "day") &&
				dateCellule.isSame(conges[1].Fin, "day") && dateCellule.isAfter(conges[1].Debut, "day") ||
				dateCellule.isBefore(conges[1].Fin, "day") && dateCellule.isSame(conges[1].Debut, "day") &&
				dateCellule.isSame(conges[0].Fin, "day") && dateCellule.isAfter(conges[0].Debut, "day")) {
				cellClass = " cell-middle-multi ";
			} else if (dateCellule.isSame(conges[0].Fin, "day") && dateCellule.isAfter(conges[0].Debut, "day") ||
				dateCellule.isSame(conges[1].Fin, "day") && dateCellule.isAfter(conges[1].Debut, "day")) {
				cellClass = " cell-right-multi ";
			} else if (dateCellule.isSame(conges[0].Debut, "day") && dateCellule.isSame(conges[0].Fin, "day") &&
				dateCellule.isSame(conges[1].Debut, "day") && dateCellule.isSame(conges[1].Fin, "day")) {
				cellClass = " cell-one-multi ";
			} else if (dateCellule.isBefore(conges[0].Fin, "day") && dateCellule.isAfter(conges[0].Debut, "day") &&
				dateCellule.isBefore(conges[1].Fin, "day") && dateCellule.isAfter(conges[1].Debut, "day")) {
				cellClass = " cell-middle-multi ";
			} else if (dateCellule.isSame(conges[0].Debut, "day") && dateCellule.isBefore(conges[0].Fin, "day") ||
				dateCellule.isSame(conges[1].Debut, "day") && dateCellule.isBefore(conges[1].Fin, "day")) {
				cellClass = " cell-left-multi ";
			}
		}

		// ------------------------- ORDER

		let absenceMatin = conges[0];
		let absenceSoir = conges[1];

		if (cellClass == " cell-left-multi " || cellClass == " cell-one-multi ") {
			if (conges[0].IsMatin && !conges[0].IsApresMidi) {
				absenceMatin = conges[0];
				absenceSoir = conges[1];
			} else {
				absenceMatin = conges[1];
				absenceSoir = conges[0];
			}
		} else if (cellClass == " cell-right-multi ") {
			if (!conges[0].IsMatin && conges[0].IsApresMidi) {
				absenceMatin = conges[1];
				absenceSoir = conges[0];
			} else {
				absenceMatin = conges[0];
				absenceSoir = conges[1];
			}
		} else if (cellClass == " cell-middle-multi ") {
			if (dateCellule.isBefore(conges[0].Fin, "day") && dateCellule.isSame(conges[0].Debut, "day") &&
				dateCellule.isSame(conges[1].Fin, "day") && dateCellule.isAfter(conges[1].Debut, "day")) {
				absenceMatin = conges[1];
				absenceSoir = conges[0];
			} else {
				absenceMatin = conges[0];
				absenceSoir = conges[1];
			}
		}

		// ------------------------- WAIT

		if (absenceMatin != undefined && absenceSoir != undefined) {
			if (!this.estValideOuPlus(absenceMatin.Etat) && !this.estValideOuPlus(absenceSoir.Etat)) {
				isWait = " wait ";
			} else if (this.estValideOuPlus(absenceMatin.Etat) && !this.estValideOuPlus(absenceSoir.Etat)) {
				isWait = " wait ok-left ";
			} else if (!this.estValideOuPlus(absenceMatin.Etat) && this.estValideOuPlus(absenceSoir.Etat)) {
				isWait = " wait ok-right ";
			}
		}

		// ------------------------- RETURN

		return cellClass + isWait;
	}

	public getColor(cell: modelDay, type: string, periode: string): any {
		let conge: CongeDto | undefined = this.getCongeInformation(cell, periode);

		if (conge == undefined || conge.TypeConges.Couleur == undefined) {
			return "";
		}

		const color = conge.TypeConges.Couleur;

		if (type == "border") {
			return this.getBorderColor(color);
		} else {
			if (!this.estValideOuPlus(conge.Etat)) {
				return "background-image: linear-gradient(135deg, #ffffff 25%, " + color + " 25%, " + color + " 50%, #ffffff 50%, #ffffff 75%, " + color + " 75%, " + color + " 100%);";
			} else {
				return this.getBackgroundColor(color);
			}
		}
	}

	private getCongeInformation(cell: modelDay, periode: string): CongeDto | undefined {
		const getAbsence: CongeDto[] = this.listAbsenceSalarie.filter(a => moment.utc(a.Date).isSame(cell.dateDay));

		const dateCellule = moment.utc(cell.dateDay);
		let conge;

		if (getAbsence.length == 0) {
			return undefined;
		}

		if (getAbsence.length == 1) {
			conge = getAbsence[0];
		} else {
			if (periode == "M") {
				if (dateCellule.isBefore(getAbsence[0].Fin, "day") && dateCellule.isSame(getAbsence[0].Debut, "day") &&
					dateCellule.isSame(getAbsence[1].Fin, "day") && dateCellule.isAfter(getAbsence[1].Debut, "day")) {
					conge = getAbsence[1];
				} else if (dateCellule.isBefore(getAbsence[1].Fin, "day") && dateCellule.isSame(getAbsence[1].Debut, "day") &&
					dateCellule.isSame(getAbsence[0].Fin, "day") && dateCellule.isAfter(getAbsence[0].Debut, "day")) {
					conge = getAbsence[0];
				} else if (dateCellule.isSame(getAbsence[0].Debut) && dateCellule.isSame(getAbsence[0].Fin) &&
					dateCellule.isBefore(getAbsence[1].Fin) && dateCellule.isSame(getAbsence[1].Debut)) {
					conge = getAbsence[0];
				} else if (dateCellule.isSame(getAbsence[1].Debut) && dateCellule.isSame(getAbsence[1].Fin) &&
					dateCellule.isBefore(getAbsence[0].Fin) && dateCellule.isSame(getAbsence[0].Debut)) {
					conge = getAbsence[1];
				} else if (getAbsence[0].IsMatin && getAbsence[1].IsMatin) {
					conge = getAbsence[1];
				} else {
					conge = (getAbsence[0].IsMatin) ? getAbsence[0] : getAbsence[1];
				}
			} else {
				if (dateCellule.isBefore(getAbsence[0].Fin, "day") && dateCellule.isSame(getAbsence[0].Debut, "day") &&
					dateCellule.isSame(getAbsence[1].Fin, "day") && dateCellule.isAfter(getAbsence[1].Debut, "day")) {
					conge = getAbsence[0];
				} else if (dateCellule.isBefore(getAbsence[1].Fin, "day") && dateCellule.isSame(getAbsence[1].Debut, "day") &&
					dateCellule.isSame(getAbsence[0].Fin, "day") && dateCellule.isAfter(getAbsence[0].Debut, "day")) {
					conge = getAbsence[1];
				} else if (dateCellule.isSame(getAbsence[0].Debut) && dateCellule.isSame(getAbsence[0].Fin) &&
					dateCellule.isAfter(getAbsence[1].Debut) && dateCellule.isSame(getAbsence[1].Fin)) {
					conge = getAbsence[0];
				} else if (dateCellule.isSame(getAbsence[1].Debut) && dateCellule.isSame(getAbsence[1].Fin) &&
					dateCellule.isAfter(getAbsence[0].Debut) && dateCellule.isSame(getAbsence[0].Fin)) {
					conge = getAbsence[1];
				} else if (getAbsence[0].IsApresMidi && getAbsence[1].IsApresMidi) {
					conge = getAbsence[1];
				} else {
					conge = (getAbsence[0].IsApresMidi) ? getAbsence[0] : getAbsence[1];
				}
			}
		}
		return conge;
	}

	public getColorInformation(cell: modelDay, periode: string): string {
		const conge = this.getCongeInformation(cell, periode);

		return conge != undefined && conge.TypeConges.Couleur != undefined ? conge.TypeConges.Couleur : "";
	}

	private getBackgroundColor(type: string): any {
		return {
			backgroundColor: type
		};
	}

	private getBorderColor(type: string): any {
		return {
			borderColor: type
		};
	}

	private estValideOuPlus(etat: EtatAbsencesEnum): boolean {
		let estValideOuPlus = false;
		if (etat == EtatAbsencesEnum.Valide ||
			etat == EtatAbsencesEnum.Calcule ||
			etat == EtatAbsencesEnum.Cloture) {
			estValideOuPlus = true;
		}

		return estValideOuPlus;
	}

	private isToday(dateCellule: Date): boolean {
		// Si il existe un congé sur la date du jour, on affiche le congé
		const getAbsence: CongeDto[] = this.listAbsenceSalarie.filter(a => moment.utc(a.Date).isSame(dateCellule, "d"));
		if (getAbsence.length > 0) {
			return false;
		}

		const momentCellule = moment.utc(dateCellule);
		const today = new Date();
		if (momentCellule.isSame(today, "d")) {
			return true;
		}

		return false;
	}

	public isCongeEnAnnulation(cell: modelDay, period: string): any {
		const conge = this.getCongeInformation(cell, period);
		if (conge == undefined) {
			return false;
		}
		const etat = conge?.Etat;
		const isFirstDay: boolean = conge?.IsFirst &&
			((!conge.IsApresMidi && period == "M")
			|| (conge.IsApresMidi && period == "A")
			|| (conge.IsApresMidi && conge.Debut != conge.Fin && period == "M"));

		return isFirstDay && (etat == EtatAbsencesEnum.EnAttenteAnnulationGestionnaire
			|| etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_1
			|| etat == EtatAbsencesEnum.EnAttenteAnnulationResponsableNiveau_2);
	}

	public isDatePickerVisibleLeft = false;
	public isDatePickerVisibleRight = false;
	public showDateSelector(event: any, isRight: boolean): void {
		event.preventDefault();
		event.stopPropagation();

		if (this.dataReady) {
			if (isRight) {
				this.isDatePickerVisibleRight = true;
				this.isDatePickerVisibleLeft = false;
			} else {
				this.isDatePickerVisibleRight = false;
				this.isDatePickerVisibleLeft = true;
			}
		}
	}

	public selectedDate(newDate: Date, isRight: boolean): void {
		this.dataReady = false;

		if (isRight) {
			const newDatePlusOneMonth: Date = moment.utc(newDate).add(1, "M").toDate();

			this.currentMonth = newDatePlusOneMonth.getUTCMonth();
			this.currentYear = newDatePlusOneMonth.getUTCFullYear();
		} else {
			const newDateUTC: Date = moment.utc(newDate).add(2, "M").toDate();

			this.currentMonth = newDateUTC.getUTCMonth();
			this.currentYear = newDateUTC.getUTCFullYear();
		}

		this.$emit("reload", this.currentMonth, this.currentYear);

		this.closeDatePicker();
	}

	public closeDatePicker(): void {
		this.isDatePickerVisibleRight = false;
		this.isDatePickerVisibleLeft = false;
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/absences/doubleCalendrier/doubleCalendrier.ts